<script lang="ts">
import type { VariantProps } from 'tailwind-variants';
import type { PageContentVariants } from './PageContent.vue';
import { tv } from 'tailwind-variants';

export const pageLayoutListing = tv({
	base: 'flex-col',
	variants: {
		bottomPadding: {
			true: 'pb-10',
			false: '',
		},
	},
});

export type PageLayoutListingVariants = VariantProps<typeof pageLayoutListing>;

interface PageLayoutListingProps {
	gutter?: boolean;
	showBottomPadding?: PageLayoutListingVariants['bottomPadding'];
	width?: PageContentVariants['width'];
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import PageContent from './PageContent.vue';

const props = withDefaults(defineProps<PageLayoutListingProps>(), {
	gutter: true,
	showBottomPadding: true,
	width: 'full-bleed',
});

const gutters = computed(() => props.gutter ? 'page' : 'none');
const className = computed(() => pageLayoutListing({ bottomPadding: props.showBottomPadding }));
</script>

<template>
	<PageContent
		:width="props.width"
		:gutters
		vertical-padding="none"
		fill
		:class="className"
	>
		<slot />
	</PageContent>
</template>
